<template>
    <div class="modal fade" :id="id" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <form v-on:submit="submit">
                    <div class="modal-header d-flex justify-content-between">
                        <h5 class="modal-title fw-bold text-black">{{ $t('feature.contents.$blocks.add') }}</h5>
                        <button class="bg-transparent border-0 close-btn lh-1 p-10 text-muted" type="button"
                            data-bs-dismiss="modal" @click="restoreData()">
                            <i class="ph-bold ph-x"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <BlockForm v-bind:block="block" v-bind:update="false" v-bind:submitted="submitted"
                            v-bind:errors="errors" />
                    </div>
                    <div class="modal-footer">
                        <div class="text-center w-100" v-if="loading">
                            <SpinnerLoading />
                        </div>
                        <button type="submit"
                            class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                            v-else>
                            {{ $t('feature.contents.$blocks.save') }}
                        </button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import API from '@/services/api/api.service';
import getBase64 from '@/utils/methods/get_base_64';
import { ContentBlock, ContentBlockType } from '@/utils/models/content.model';
import { defineComponent } from 'vue';

import BlockForm from "@/components/FK/Contents/Blocks/BlockForm.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";

export default defineComponent({
    props: {
        id: {
            type: String,
            required: true
        },
        content_id: {
            type: [String, Number],
            required: true
        },
        order: {
            type: Number,
            required: false,
        }
    },
    data() {
        return {
            block: {
                type: 'text',
                content_id: this.content_id,
                subtitle: {},
                value: {}
            } as ContentBlock,
            block_types: ['text', 'image', 'video'] as ContentBlockType[],
            submitted: false,
            loading: false,
            errors: undefined as any,
        }
    },
    emits: ['save'],
    methods: {
        restoreData() {
            this.resetBlock();
            this.submitted = false;
            this.loading = false;
            this.errors = undefined as any;
        },
        async fileUploaded($event) {
            this.block.value = await getBase64($event.target.files[0]);
        },
        resetBlock() {
            this.block = { ...this.block, subtitle: {}, value: {}, type: 'text' } as ContentBlock;
        },
        submit(event) {
            this.errors = undefined;
            this.loading = true;
            event.preventDefault();
            console.log('SUBMIT');
            console.log(this.block);
            API.createContentBlockLocalization({ content_id: this.content_id, block: this.block, order: this.order }).then((response) => {
                console.log(response);
                if (response.data.success === true && response.data.data != undefined) {
                    let subtitle = {};
                    let value = {};
                    subtitle[process.env.VUE_APP_LANG] = response.data.data.subtitle;
                    value[process.env.VUE_APP_LANG] = response.data.data.value;
                    this.restoreData();
                    this.$emit('save', { ...response.data.data, subtitle: subtitle, value: value, order: this.order } as ContentBlock);
                } else {
                    throw Error()
                }
            }).catch((error) => {
                this.errors = error.response?.data?.errors;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    components: {
        SpinnerLoading,
        BlockForm
    },
    name: "ContentBlockModal",
});
</script>